import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RepaymentListOldPageUI from './RepaymentListOldPageUI.js'

class RepaymentListOldPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      repaymentList: null,
      nextRepaymentList: null,
      totals: null
    }
  }

  render() {
    return (
      <RepaymentListOldPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        repaymentList={this.state.repaymentList}
        nextRepaymentList={this.state.nextRepaymentList}
        onRefreshClick={this.onRefreshClick}
        totals={this.state.totals}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getRepayments(context)
  }

  getRepayments(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/repayments`,
      cacheKey: CacheKeys.AllRepayments(),
      callback: this.getRepaymentsCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context, {}, {})
  }

  getRepaymentsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      repaymentList : response.repaymentList,
      nextRepaymentList: response.nextRepaymentList,
      totals: response
    })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.AllRepayments())
    this.setState({repaymentList: null, nextRepaymentList:null, errorList: null, totals: null})
    this.getRepayments(this.props.context)
  }
}

export default RepaymentListOldPageSF
